import { createAxios, createDealerAxios } from 'src/factories/axios-factory';
import { BespokeRate } from 'src/types/quote/index';
import { DealerUserSettings, DealerGroupResponse, DealerInfo, DealerSettings } from 'src/types/dealer/index';
import PortalVersion from 'src/types/dealer/portal-version';
import axios from 'axios';

const dealerBackendClient = createAxios(process.env.DealersApiUrl!);
const dealerBackendUser = createDealerAxios(process.env.DealersApiUrl!);

const dealerService = {
  getDealersByUserId(userId: number) {
    return new Promise<DealerInfo[]>(async (resolve, reject) => {

      dealerBackendClient.get(
        `/dealer/get-dealers-by-region?userId=${userId}`
      ).then(res => {
        resolve(res.data);
      }).catch(error => {
        console.log("no asm dealers");
      })
     
    })
  },
  getDealers() {
    return new Promise<any[]>(async (resolve, reject) => {

      dealerBackendClient.get(
        `/dealer/dealers`
      ).then(res => {
        resolve(res.data);
      }).catch(error => {
        console.log("no dealers");
      })

    })
  },
  getDealerGroup(affiliateUserId: number) {
    return new Promise<DealerGroupResponse | null>(async (resolve, reject) => {

      dealerBackendUser.get(
        `/dealer/group/${affiliateUserId}`
      ).then(res => {
        resolve(res.data as DealerGroupResponse);
      }).catch(error => {
        console.log("no dealer group");
        resolve(null)
      })

    })
  },
  getAllGroups() {
    return new Promise<DealerGroupResponse[] | null>(async (resolve, reject) => {

      dealerBackendUser.get(
        `/dealer/groups`
      ).then(res => {
        resolve(res.data as DealerGroupResponse[]);
      }).catch(error => {
        console.log("no dealer group");
        resolve(null)
      })

    })
  },
  getBespokeRates(affiliateUserId: number) {
    return new Promise<BespokeRate[]>(async (resolve, reject) => {
		// for dealers who do not want bespoke rates in portal
		if(affiliateUserId == 19979){
			resolve([]);
			return;
		}

		dealerBackendClient.get(
			`/rates/${affiliateUserId}`
		).then(res => {
			resolve(res.data as BespokeRate[]);
		}).catch(error => {
			console.log("no rates");
			resolve([]);
		})
    })
  },
  getUserSettings(dealerUserId: number) {
    return new Promise<DealerUserSettings>(async (resolve, reject) => {

      dealerBackendUser.get(`/dealer/user-settings/${dealerUserId}`).then(res => {
        resolve(res.data as DealerUserSettings);
      }).catch(error => {
        console.log("no rates");
        reject(error);
      })

    })
  },
  updateUserSettings(userSettings: DealerUserSettings) {
    return new Promise<DealerUserSettings>(async (resolve, reject) => {
      dealerBackendUser.post(`/dealer/user-settings`, userSettings).then(res => {
        resolve(res.data as DealerUserSettings);
      }).catch(error => {
        console.log("no rates");
        reject(error);
      })

    })
  },
  updateDealerSettings(dealerSettings: DealerSettings) {        

    console.log(dealerSettings);
    return new Promise<DealerSettings>(async (resolve, reject) => {
      dealerBackendUser.post(`/dealer/dealer-settings`, dealerSettings).then(res => {
        resolve(res.data as DealerSettings);
      }).catch(error => {
        console.log("error updating dealer settings");
        reject(error);
      })

    })
  },
  getDealerSettings(affiliateId: number) {
    console.log(affiliateId);
    return new Promise<DealerSettings>(async (resolve, reject) => {
      dealerBackendUser.get(`/dealer/settings/${affiliateId}`).then(res => {
        resolve(res.data as DealerSettings);
      }).catch(error => {
        console.log("errorgetting dealer settings");
        reject(error);
      })

    })
  },
  getPortalVersions() {
    return new Promise<PortalVersion[]>(async (resolve, reject) => {
      axios.get(`https://apim.247prod.io/api/dealer/v3/portal-versions`)
        .then(res => {
          resolve(res.data as PortalVersion[]);
        })
        .catch(error => {
          resolve([] as PortalVersion[]);
        });
    });
  },
};

export default dealerService;
